var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNorfolkIsland(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 512,
    viewBox: "0 0 513 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_7241)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M368.292 25.402C334.636 9.128 296.879 0 256.988 0C217.097 0 179.34 9.128 145.684 25.402L123.423 256L145.684 486.598C179.34 502.872 217.097 512 256.988 512C296.879 512 334.636 502.872 368.292 486.598L390.553 256L368.292 25.402Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.684 25.4109C60.0533 66.8169 0.988281 154.506 0.988281 256C0.988281 357.494 60.0533 445.183 145.684 486.589V25.4109Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.292 25.4109V486.589C453.923 445.183 512.988 357.493 512.988 256C512.988 154.507 453.923 66.8169 368.292 25.4109Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.771 333.913L256.988 122.435L190.205 333.913H240.292V389.565H273.684V333.913H323.771Z",
    fill: "#6DA544"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_7241"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white",
    transform: "translate(0.988281)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNorfolkIsland);
export default __webpack_public_path__ + "static/media/norfolkIsland.b852cd55ed88e5bd495fac74afb2e807.svg";
export { ForwardRef as ReactComponent };